import { render, staticRenderFns } from "./AuthoritativeCertificationContent.vue?vue&type=template&id=8b0bb108&scoped=true&"
import script from "./AuthoritativeCertificationContent.vue?vue&type=script&lang=js&"
export * from "./AuthoritativeCertificationContent.vue?vue&type=script&lang=js&"
import style0 from "./AuthoritativeCertificationContent.vue?vue&type=style&index=0&id=8b0bb108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0bb108",
  null
  
)

export default component.exports